module.exports = __webpack_public_path__ + "img/ringwedding@2x.8e1cde1.webp";